import {
  FilterFieldDef,
  OPS_BOOLEAN,
  OPS_DATE_FULL,
  OPS_LIST,
  OPS_NUM_FULL,
  OPS_TEXT_CONTAINS,
  OPS_TEXT_FULL,
  OPS_TEXT_ID,
} from '../../../components/molecules/FilterBar/AddFilterModal.types';

/** Category tabs shown in the Add Filter modal sidebar. Derived from the
 *  partListColumnSelectionItems groupings ("Part", "Part Type", "Structure",
 *  "Labels") plus domain groupings that don't map one-to-one. */
export const PART_FILTER_CATEGORIES = [
  'All',
  'Part',
  'Serials',
  'Part Type',
  'Location',
  'Exception',
  'Audit',
];

export const PART_FILTER_FIELD_DEFINITIONS: FilterFieldDef[] = [
  // ── Part ─────────────────────────────────────────────────────
  { name: 'Asset ID', key: 'assetId', type: 'number', category: 'Part', operators: OPS_NUM_FULL },
  {
    name: 'Condition',
    key: 'conditionName',
    type: 'list',
    category: 'Part',
    operators: OPS_LIST,
  },
  {
    name: 'Serialised',
    key: 'serialised',
    type: 'list',
    category: 'Part',
    operators: OPS_LIST,
  },
  {
    name: 'Contract(s)',
    key: 'contract',
    type: 'text',
    category: 'Part',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Client',
    key: 'client',
    type: 'text',
    category: 'Part',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Fleet Tag',
    key: 'fleetTagName',
    type: 'text',
    category: 'Part',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Tags',
    key: 'tags',
    type: 'list',
    category: 'Part',
    operators: OPS_LIST,
  },
  {
    name: 'Quantity in Stock',
    key: 'quantityInStock',
    type: 'number',
    category: 'Part',
    operators: OPS_NUM_FULL,
  },
  {
    name: 'Notes',
    key: 'notes',
    type: 'text',
    category: 'Part',
    operators: OPS_TEXT_CONTAINS,
  },
  {
    name: 'Active',
    key: 'isActive',
    type: 'boolean',
    category: 'Part',
    operators: OPS_BOOLEAN,
  },
  {
    name: 'Warranty End',
    key: 'warrantyEnd',
    type: 'date',
    category: 'Part',
    operators: OPS_DATE_FULL,
  },

  // ── Serials ──────────────────────────────────────────────────
  {
    name: 'Serial 1',
    key: 'serial1',
    type: 'text',
    category: 'Serials',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Serial 2',
    key: 'serial2',
    type: 'text',
    category: 'Serials',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Serial 3',
    key: 'serial3',
    type: 'text',
    category: 'Serials',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Software Version',
    key: 'softwareVersion',
    type: 'text',
    category: 'Serials',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Firmware Version',
    key: 'firmwareVersion',
    type: 'text',
    category: 'Serials',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Hardware Revision',
    key: 'hardwareVersion',
    type: 'text',
    category: 'Serials',
    operators: OPS_TEXT_FULL,
  },

  // ── Part Type ────────────────────────────────────────────────
  {
    name: 'Part Type ID',
    key: 'partTypeId',
    type: 'text',
    category: 'Part Type',
    operators: OPS_TEXT_ID,
  },
  {
    name: 'Part Type Name',
    key: 'partTypeName',
    type: 'text',
    category: 'Part Type',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Part No.',
    key: 'partTypeNumber',
    type: 'text',
    category: 'Part Type',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Part Type Tags',
    key: 'partTypeTags',
    type: 'text',
    category: 'Part Type',
    operators: OPS_TEXT_CONTAINS,
  },
  {
    name: 'Part Type Active',
    key: 'partTypeIsActive',
    type: 'boolean',
    category: 'Part Type',
    operators: OPS_BOOLEAN,
  },

  // ── Location ─────────────────────────────────────────────────
  {
    name: 'Location',
    key: 'location',
    type: 'text',
    category: 'Location',
    operators: OPS_TEXT_CONTAINS,
  },
  {
    name: 'Node ID',
    key: 'nodeId',
    type: 'text',
    category: 'Location',
    operators: OPS_TEXT_ID,
  },
  {
    name: 'Node Name',
    key: 'nodeName',
    type: 'text',
    category: 'Location',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Node Type',
    key: 'nodeTypeName',
    type: 'list',
    category: 'Location',
    operators: OPS_LIST,
  },
  {
    name: 'Parent Type',
    key: 'locationTypeCode',
    type: 'list',
    category: 'Location',
    operators: OPS_LIST,
  },

  // ── Exception ────────────────────────────────────────────────
  {
    name: 'Exception Status',
    key: 'exceptionStatus',
    type: 'list',
    category: 'Exception',
    operators: OPS_LIST,
  },
  {
    name: 'Exception Service ID',
    key: 'exceptionServiceId',
    type: 'text',
    category: 'Exception',
    operators: OPS_TEXT_ID,
  },
  {
    name: 'Exception Result Note',
    key: 'exceptionResultNote',
    type: 'text',
    category: 'Exception',
    operators: OPS_TEXT_CONTAINS,
  },

  // ── Audit ────────────────────────────────────────────────────
  {
    name: 'Created At',
    key: 'createdAt',
    type: 'date',
    category: 'Audit',
    operators: OPS_DATE_FULL,
  },
  {
    name: 'Created By',
    key: 'createdByName',
    type: 'text',
    category: 'Audit',
    operators: OPS_TEXT_FULL,
  },
  {
    name: 'Updated At',
    key: 'updatedAt',
    type: 'date',
    category: 'Audit',
    operators: OPS_DATE_FULL,
  },
  {
    name: 'Updated By',
    key: 'updatedByName',
    type: 'text',
    category: 'Audit',
    operators: OPS_TEXT_FULL,
  },
];
